var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBagNormal = function SvgBagNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 56"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bag-normal_svg__a",
    d: "M0 0h60v60H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-10 -2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bag-normal_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bag-normal_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M50 14v44H10V14zm-1.818 2H11.818v40h36.364z",
    mask: "url(#bag-normal_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M30 2c6.075 0 11 4.925 11 11v9h-2v-9a9 9 0 0 0-18 0v9h-2v-9c0-6.075 4.925-11 11-11",
    mask: "url(#bag-normal_svg__b)"
  }))));
};
export default SvgBagNormal;